import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function ComplyLayoutRoute() {
    // The "not complete yet" banner for a `wip` section is in FrontendLayout,
    // so it covers all four views. Comply carries the most WIP rows, but Desk
    // has one too (Benchmarking, SEP-199).
    return (
        <FrontendLayout frontend="comply">
            <Outlet />
        </FrontendLayout>
    );
}
